import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Typography,
  Avatar,
  Box,
  IconButton,
  TextField,
  Tooltip,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Menu,
  MenuItem,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import QuizIcon from "@mui/icons-material/Quiz";
import FolderIcon from "@mui/icons-material/Book";
import SettingsIcon from "@mui/icons-material/Settings";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import ShortTextIcon from "@mui/icons-material/ShortText";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import { getToken } from "../utils/Authe";
import { styled } from "@mui/material/styles";
import LogoutIcon from '@mui/icons-material/Logout';
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { clearToken } from "../utils/Authe";
import { useTheme as useMuiTheme } from '@mui/material/styles';
import { useThemeMode  } from "../context/ThemeContext";
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';


const CustomScrollbar = styled("div")({
  "&::-webkit-scrollbar": {
    width: "6px",
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "transparent",
    borderRadius: "3px",
  },
  "&:hover::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(102, 126, 234, 0.3)",
  },
  "&:hover::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "rgba(102, 126, 234, 0.5)",
  },
  scrollbarWidth: "thin",
  scrollbarColor: "transparent transparent",
  "&:hover": {
    scrollbarColor: "rgba(102, 126, 234, 0.3) transparent",
  },
  overflowY: "auto",
  height: "100%",
  maxHeight: "calc(100vh - 300px)", // Adjust this value based on your layout
});


const Sidebar = ({ children, showRightToolbar = false }) => {
   const muiTheme = useMuiTheme();
  const { mode, toggleTheme } = useThemeMode();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [folders, setFolders] = useState([]);
  const [openFolders, setOpenFolders] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [folderToDelete, setFolderToDelete] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const token = getToken();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
const [activeItem, setActiveItem] = useState(null);
const [searchQuery, setSearchQuery] = useState("");
const [filteredFolders, setFilteredFolders] = useState([]);
const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);
const [loading, setLoading] = useState(false);


  const rightButtons = [
    { icon: <TextFieldsIcon />, label: "Single Line Question", path: `/single-line/${id}` },
    { icon: <ShortTextIcon />, label: "Fill in the Blanks", path: `/fill-in-the-blanks/${id}` },
    { icon: <QuizIcon />, label: "Multiple Choice", path: `/multiple-choice/${id}` },
    { icon: <CheckBoxIcon />, label: "True/False", path: `/true-false/${id}` },
  ];
  
  useEffect(() => {
  if (searchQuery.trim() === "") {
    setFilteredFolders(folders);
  } else {
    const filtered = folders.filter((folder) =>
      folder.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredFolders(filtered);
  }
}, [searchQuery, folders]);

useEffect(() => {
  const path = location.pathname;
  if (path.includes("/dashboard")) {
    setActiveItem("dashboard");
  } else if (path.includes("/quiz-creation")) {
    setActiveItem("quiz-creation");
  } else if (path.includes("/control-panel")) {
    setActiveItem("control-panel");
  } else if (path.includes("/single-line/") || path.includes("/fill-in-the-blanks/") || path.includes("/multiple-choice/") || path.includes("/true-false/")) {
    setActiveItem(null); // Or set to a specific folder ID if applicable
  } else {
    setActiveItem(null);
  }
}, [location.pathname]);

  useEffect(() => {


    const fetchFolders = async () => {
      setLoading(true);
      try {
        const apiUrl = `http://warals1.ddns.net:9018`;
        const response = await fetch(`${apiUrl}/folders/`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        if (!response.ok) throw new Error("Failed to fetch folders");
        const data = await response.json();
        setFolders(data);
      } catch (error) {
        console.error("Error fetching folders:", error);
        navigate("/login");
      } finally {
    setLoading(false);
      }
    };
    if (token) fetchFolders();
  }, [token]);

  const handleAddFolder = async () => {
    try {
      const apiUrl = `http://warals1.ddns.net:9018`;
      const response = await fetch(`${apiUrl}/folders/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name: newFolderName }),
      });
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.error === "Course with this name already exists under the parent.") {
          setSnackbarMessage("Course name already exists");
          setSnackbarOpen(true);
          setSnackbarSeverity("error");
          return;
        }
        throw new Error("Failed to add course");
      }
      const data = await response.json();
      setFolders([...folders, data]);
      setNewFolderName("");
      setOpenDialog(false);
      setSnackbarMessage("Course created successfully!");
      setSnackbarOpen(true);
      setSnackbarSeverity("success");
    } catch (error) {
      console.error("Error adding course:", error);
    }
  };

  const handleDeleteFolder = async () => {
    try {
      const apiUrl = `http://warals1.ddns.net:9018`;
      const response = await fetch(`${apiUrl}/folders/${folderToDelete}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error("Failed to delete course");
      setSnackbarMessage("Course Deleted Successfully!");
      setSnackbarOpen(true);
      setSnackbarSeverity("success");
      setFolders(folders.filter((folder) => folder.id !== folderToDelete));
      setDeleteConfirmOpen(false);
    } catch (error) {
      console.error("Error deleting course:", error);
    }
  };

  const handleToggle = (folderId) => {
    setOpenFolders((prev) => ({ ...prev, [folderId]: !prev[folderId] }));
  };

  const openDeleteConfirm = (folderId) => {
    setFolderToDelete(folderId);
    setDeleteConfirmOpen(true);
    setAnchorEl(null);
  };

  const handleMenuOpen = (event, folderId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setFolderToDelete(folderId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  try {
    const response = await fetch(`${baseUrl}/client-admin/logout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });
    if (response.ok) {
      clearToken();
      navigate("/login");
    } else {
      console.error("Logout failed");
    }
  } catch (error) {
    console.error("Error during logout:", error);
  }
};

  const renderFolderTree = (folderList) => {
    return folderList.map((folder) => (
      <React.Fragment key={folder.id}>
        <ListItem
          disablePadding
          secondaryAction={
            <IconButton
              edge="end"
              onClick={(e) => handleMenuOpen(e, folder.id)}
              sx={{ color: "text.secondary" }}
            >
              <MoreVertIcon />
            </IconButton>
          }
        >
          <ListItemButton
  onClick={() => {
    navigate(`/single-line/${folder.id}`);
    setActiveItem(folder.id);
  }}
  sx={{
    borderRadius: "12px",
    background: activeItem === folder.id ? "rgba(102, 126, 234, 0.2)" : "transparent",
    "&:hover": {
      background: "rgba(102, 126, 234, 0.1)",
    },
  }}
>
            <ListItemIcon>
              <FolderIcon sx={{ color: "#667eea" }} />
            </ListItemIcon>
            <ListItemText
              primary={folder.name}
              primaryTypographyProps={{ fontWeight: "600", color: muiTheme.palette.text.primary }}
            />
            {folder.subfolders && folder.subfolders.length > 0 ? (
              openFolders[folder.id] ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )
            ) : null}
          </ListItemButton>
        </ListItem>
        {folder.subfolders && folder.subfolders.length > 0 && (
          <Collapse in={openFolders[folder.id]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pl: 4 }}>
              {renderFolderTree(folder.subfolders)}
            </List>
          </Collapse>
        )}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl) && folderToDelete === folder.id}
          onClose={handleMenuClose}
          sx={{
            "& .MuiPaper-root": {
              boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(0, 0, 0, 0.12)",
            },
          }}
        >
          <MenuItem onClick={() => openDeleteConfirm(folder.id)}>
            <DeleteIcon sx={{ mr: 1, color: "error.main" }} /> Delete
          </MenuItem>
        </Menu>
      </React.Fragment>
    ));
  };

  return (
    <>
      <Drawer
        variant="permanent"
       sx={{
  width: 260,
  flexShrink: 0,
  "& .MuiDrawer-paper": {
    width: 260,
    background: muiTheme.palette.background.paper,
    boxShadow: muiTheme.palette.mode === 'light'
      ? "0 20px 60px rgba(0, 0, 0, 0.05)"
      : "0 20px 60px rgba(0, 0, 0, 0.2)",
    borderRight: `1px solid ${muiTheme.palette.divider}`,
  },
}}

      >
       
<Box
  sx={{
    background: muiTheme.palette.mode === 'light'
      ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
      : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }}
>

  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
    <Tooltip title="Admin Profile" arrow>
      <IconButton
        onClick={() => navigate("/admin-profile")}
        sx={{ p: 0 }}
      >
        <Avatar sx={{ bgcolor: "white", color: "#667eea" }}>👤</Avatar>
      </IconButton>
    </Tooltip>
    <Tooltip title={mode === 'light' ? 'Dark Mode' : 'Light Mode'} arrow placement="right">
      <IconButton
        onClick={toggleTheme}
        sx={{ 
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
      >
        {mode === 'light' ? <Brightness4Icon /> : <Brightness7Icon />}
      </IconButton>
    </Tooltip>
  </Box>
  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
    Welcome, Admin!
  </Typography>
  <Typography variant="body2">Admin</Typography>
</Box>
        <List sx={{ mt: 2, px: 1 }}>
          <ListItem disablePadding sx={{ mb: 1 }}>
           <ListItemButton
  onClick={() => {
    navigate("/dashboard");
    setActiveItem("dashboard");
  }}
  sx={{
    borderRadius: "12px",
    background: activeItem === "dashboard" ? "rgba(102, 126, 234, 0.2)" : "transparent",
    "&:hover": {
      background: "rgba(102, 126, 234, 0.1)",
    },
  }}
>
              <ListItemIcon>
                <HomeIcon sx={{ color: "#667eea" }} />
              </ListItemIcon>
              <ListItemText
                primary="Home Page"
                primaryTypographyProps={{ fontWeight: "600", color: muiTheme.palette.text.primary }}
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding >
           <ListItemButton
  onClick={() => {
    navigate("/quiz-creation");
    setActiveItem("quiz-creation");
  }}
  sx={{
    borderRadius: "12px",
    background: activeItem === "quiz-creation" ? "rgba(102, 126, 234, 0.2)" : "transparent",
    "&:hover": {
      background: "rgba(102, 126, 234, 0.1)",
    },
  }}
>
              <ListItemIcon>
                <QuizIcon sx={{ color: "#667eea" }} />
              </ListItemIcon>
              <ListItemText
                primary="Quiz Creation"
                primaryTypographyProps={{ fontWeight: "600", color: muiTheme.palette.text.primary }}
              />
            </ListItemButton>
          </ListItem>
        </List>
         <List sx={{ px: 1 }}>
          <ListItem disablePadding>
<ListItemButton
  onClick={() => {
    navigate("/control-panel");
    setActiveItem("control-panel");
  }}
  sx={{
    borderRadius: "12px",
    background: activeItem === "control-panel" ? "rgba(102, 126, 234, 0.2)" : "transparent",
    "&:hover": {
      background: "rgba(102, 126, 234, 0.1)",
    },
  }}
>
              <ListItemIcon>
                <SettingsIcon sx={{ color: "#667eea" }} />
              </ListItemIcon>
              <ListItemText
                primary="Control Panel"
                primaryTypographyProps={{ fontWeight: "600", color: muiTheme.palette.text.primary }}
              />
            </ListItemButton>
          </ListItem>
        </List>
        
        <Divider sx={{ my: 1, bgcolor: muiTheme.palette.divider }} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              color: muiTheme.palette.text.primary,
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            Courses
          </Typography>
          <Tooltip title="Add Courses">
            <IconButton onClick={() => setOpenDialog(true)} sx={{ color: "#667eea" }}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </Box>

      <Box sx={{ px: 2, my: 1 }}>
  <TextField
    fullWidth
    variant="outlined"
    placeholder="Search Courses..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    size="small"
    sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        backgroundColor: "rgba(102, 126, 234, 0.05)",
        "& fieldset": {
          borderColor: "rgba(102, 126, 234, 0.2)",
        },
        "&:hover fieldset": {
          borderColor: "rgba(102, 126, 234, 0.5)",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#667eea",
        },
      },
    }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon sx={{ color: "rgba(102, 126, 234, 0.7)" }} />
        </InputAdornment>
      ),
        sx: {
        "& input": {
          fontSize: "0.89rem", // Adjust this value as needed
        },
      }
    }}
  />
</Box>
  <CustomScrollbar>
      <List sx={{ px: 1 }}>
        {loading ? (
      <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
        <CircularProgress size={24} />
      </Box>
  ) : filteredFolders.length > 0 ? (
    renderFolderTree(filteredFolders)
  ) : (
    <Typography sx={{ pl: 3, pt: 1, color: "gray" }}>
      {searchQuery ? "No match found" : " "}
    </Typography>
  )}
</List>
</CustomScrollbar>

        <Box sx={{ flexGrow: 1 }} />
        <Divider sx={{ my: 2, bgcolor: muiTheme.palette.divider }} />
        <List sx={{ px: 1 }}>
          <ListItem disablePadding>
<ListItemButton
    onClick={() => setLogoutConfirmOpen(true)}
  sx={{
    borderRadius: "12px",
    background: activeItem === "logout" ? "rgba(102, 126, 234, 0.2)" : "transparent",
    "&:hover": {
      background: "rgba(102, 126, 234, 0.1)",
    },
  }}
>
              <ListItemIcon>
                <LogoutIcon sx={{ color: "red" }} />
              </ListItemIcon>
              <ListItemText
                primary="Logout"
                primaryTypographyProps={{ fontWeight: "600", color: "red" }}
              />
            </ListItemButton>
          </ListItem>
        </List>
       
      </Drawer>
      <Box
        sx={{
          marginLeft: "260px",
          width: "calc(100% - 260px)",
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%)",
        }}
      >
        {children}
      </Box>
     {showRightToolbar && (
  <Box
    sx={{
      position: "fixed",
      top: "50%",
      right: 0,
      transform: "translateY(-50%)",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      borderLeft: "none",
      borderRadius: "8px 0 0 8px",
      display: "flex",
      flexDirection: "column",
      p: 0.5,
      width: "40px",
      boxShadow: "-2px 0 6px rgba(0,0,0,0.1)",
      zIndex: 1000,
    }}
  >
    {rightButtons.map((btn, index) => (
      <Tooltip key={index} title={btn.label} placement="left" arrow>
        <IconButton
          sx={{
            my: 0.5,
            color: "#f8f9ff",
            width: "32px",
            height: "32px",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            },
          }}
          onClick={() => navigate(btn.path)}
        >
          {btn.icon}
        </IconButton>
      </Tooltip>
    ))}
  </Box>
)}

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        aria-labelledby="add-folder-dialog-title"
        aria-describedby="add-folder-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          id="add-folder-dialog-title"
          sx={{
            fontWeight: "bold",
            color: "#667eea",
            display: "flex",
            alignItems: "center",
          }}
        >
          <CreateNewFolderIcon sx={{ color: "#667eea", mr: 1 }} />
          Add New Courses
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ mb: 2 }}>
            <Typography variant="body1" sx={{ fontWeight: "medium", mb: 1 }}>
              Enter the name for the new Course:
            </Typography>
            <TextField
              autoFocus
              margin="dense"
              label="Course Name"
              fullWidth
              value={newFolderName}
              onChange={(e) => setNewFolderName(e.target.value)}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1,
                },
              }}
            />
          </Box>
          <Typography
            variant="body2"
            sx={{
              mt: 1,
              p: 1.5,
              backgroundColor: "#f0f4ff",
              borderRadius: 1,
              borderLeft: "4px solid",
              borderColor: "#667eea",
              color: "#3c4043",
            }}
          >
            <strong>Note:</strong> Ensure the Course name is unique and descriptive.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
          <Button
            onClick={() => setOpenDialog(false)}
            variant="outlined"
            color="inherit"
            sx={{ borderColor: "grey.400" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddFolder}
            variant="contained"
            color="primary"
            autoFocus
            startIcon={<AddIcon />}
            sx={{ boxShadow: "none", bgcolor: "#667eea", "&:hover": { bgcolor: "#5a6fd1" } }}
          >
            Add Courses
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold", color: "error.main" }}>
          Confirm Deletion
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <DeleteIcon sx={{ color: "error.main", mr: 1 }} />
            <Typography variant="body1" sx={{ fontWeight: "medium" }}>
              Are you sure you want to delete this Course ?
            </Typography>
          </Box>
          <Typography
            variant="body2"
            sx={{
              mt: 1,
              p: 1.5,
              backgroundColor: "error.lighter",
              borderRadius: 1,
              borderLeft: "4px solid",
              borderColor: "error.main",
              color: "error.dark",
            }}
          >
            <strong>Note:</strong> To avoid any conflicts, please delete this Course from WIMS as well.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
          <Button
            onClick={() => setDeleteConfirmOpen(false)}
            variant="outlined"
            color="inherit"
            sx={{ borderColor: "grey.400" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteFolder}
            variant="contained"
            color="error"
            autoFocus
            startIcon={<DeleteIcon />}
            sx={{ boxShadow: "none" }}
          >
            Delete Permanently
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbarSeverity}
          onClose={() => setSnackbarOpen(false)}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Dialog
  open={logoutConfirmOpen}
  onClose={() => setLogoutConfirmOpen(false)}
  aria-labelledby="logout-confirm-dialog-title"
  aria-describedby="logout-confirm-dialog-description"
  maxWidth="xs"
  fullWidth
>
  <DialogTitle id="logout-confirm-dialog-title" sx={{ fontWeight: "bold", color: "error.main" }}>
    Confirm Logout
  </DialogTitle>
  <DialogContent dividers>
    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      <LogoutIcon sx={{ color: "error.main", mr: 1 }} />
      <Typography variant="body1" sx={{ fontWeight: "medium" }}>
        Are you sure you want to logout?
      </Typography>
    </Box>
    <Typography
      variant="body2"
      sx={{
        mt: 1,
        p: 1.5,
        backgroundColor: "error.lighter",
        borderRadius: 1,
        borderLeft: "4px solid",
        borderColor: "error.main",
        color: "error.dark",
      }}
    >
      <strong>Note:</strong> You will need to log in again to access your account.
    </Typography>
  </DialogContent>
  <DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
    <Button
      onClick={() => setLogoutConfirmOpen(false)}
      variant="outlined"
      color="inherit"
      sx={{ borderColor: "grey.400" }}
    >
      Cancel
    </Button>
    <Button
      onClick={handleLogout}
      variant="contained"
      color="error"
      autoFocus
      startIcon={<LogoutIcon />}
      sx={{ boxShadow: "none" }}
    >
      Logout
    </Button>
  </DialogActions>
</Dialog>

    </>
  );
};

export default Sidebar;
